import vod from "../pages/vod/routes";
import search from "../pages/search/routes";
import livetv from "../pages/livetv/routes";


export default [...vod, ...search, ...livetv];